import { Box, Container, Typography, Button } from "@mui/material";
import long from "../assets/long.jpeg";
import { useNavigate } from "react-router-dom";
const brandBlue = "#1a237e";
const brandRed = "#d50000";

const aboutImage =
 long

export default function AboutUsSnapshot() {
   const navigate = useNavigate();
  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: "#f5f5f5",
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: 4, md: 6 },
          }}
        >
          {/* LEFT - Text */}
          <Box sx={{ flex: 1 }}>
            {/* Section Header */}
            <Typography
              sx={{
                textTransform: "uppercase",
                letterSpacing: 2,
                fontWeight: 900,
                mb: 3,
                color: brandBlue,
                display: "inline-block",
                px: 2,
                py: 0.8,
                fontSize: "0.95rem",
                borderRadius: 4,
                border: "1px solid rgba(26,35,126,0.5)",
                boxShadow: "0 0 10px rgba(26,35,126,0.25)",
                background: "rgba(26,35,126,0.1)",
                backdropFilter: "blur(4px)",
              }}
            >
              About Us Snapshot
            </Typography>

            {/* Title */}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 900,
                fontSize: { xs: "1.8rem", md: "2.8rem" },
                mb: 3,
                color: "#111",
                lineHeight: 1.3,
              }}
            >
              Engineering Excellence, Built on Trust
            </Typography>

            {/* Description */}
            <Typography
              sx={{
                fontSize: { xs: "0.95rem", md: "1.15rem" },
                mb: 4,
                color: "#333",
                maxWidth: "600px",
                lineHeight: 1.6,
              }}
            >
              At Burj Al Yarmouk Industries LLC, we specialize in premium metal engineering solutions for industrial and power generation applications. From industrial fuel tanks and acoustic enclosures to modular structures and custom metal fabrication, our expertise ensures precision, durability, and innovation in every project. We deliver robust, long-lasting engineered metal solutions you can rely on.
            </Typography>

            {/* CTA Button */}
            <Button
            onClick={()=> navigate("/about-us")}
              sx={{
                px: 4,
                py: 1.3,
                fontSize: "1rem",
                fontWeight: 700,
                textTransform: "none",
                borderRadius: 6,
                color: "#fff",
                background: brandRed,
                boxShadow: "0 6px 20px rgba(213,0,0,0.4)",
                "&:hover": {
                  background: "#b40000",
                  boxShadow: "0 8px 24px rgba(180,0,0,0.5)",
                },
              }}
            >
              Learn More
            </Button>
          </Box>

          {/* RIGHT - Image */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
            }}
          >
            <Box
              component="img"
              src={aboutImage}
              alt="About Us"
              sx={{
                width: { xs: "80%", md: "100%" },
                maxWidth: "480px",
                borderRadius: 3,
                boxShadow: "0 12px 30px rgba(0,0,0,0.2)",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
